import { render, staticRenderFns } from "./SportHeaderBetSpecial.vue?vue&type=template&id=44dfccf0&scoped=true"
import script from "./SportHeaderBetSpecial.vue?vue&type=script&lang=js"
export * from "./SportHeaderBetSpecial.vue?vue&type=script&lang=js"
import style0 from "./SportHeaderBetSpecial.vue?vue&type=style&index=0&id=44dfccf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dfccf0",
  null
  
)

export default component.exports